import { message } from 'antd'
import DocumentsApi from '../../../../api/Documents'
import { PayrollApi } from '../../../../api/People/Payroll'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import { isEmpty, pick } from 'lodash'
import { get } from 'lodash'
import React, { useState } from 'react'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { withRouter } from 'react-router-dom'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import AddPayroll from '../../../../components/People/Payroll/AddPayroll/AddPayroll'
import { MODAL_TYPE_EDIT } from '../../../../elements/Hooks/useModalData'
import { MODAL_TYPE_NEW } from '../../../../elements/Hooks/useModalData'
import useSelectionTable from '../../../../elements/Hooks/useSelectionTable'

const docsApi = new DocumentsApi()
const formRef = React.createRef()

function AddPayrollCont(props) {
  const key = get(props.match, 'params.key')
  const type = key ? MODAL_TYPE_EDIT : MODAL_TYPE_NEW
  const [generating, submitGenerate] = useSubmit(PayrollApi.generate, true)
  const [generatedData, setGeneratedData] = useState([])

  async function onGenerate() {
    const d = await checkForm()
    const data = await submitGenerate(d)
    setGeneratedData(data)
  }

  const { fetch, fetching, object: payroll, setObject: setPayroll } = useFetchObject(
    () => PayrollApi.get(key),
    false,
    [key],
    isEmpty(key)
  )
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('payrolls', payroll.status),
    [payroll.status, isEmpty(payroll.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(PayrollApi.operation)

  const [updating, updateFunc] = useSubmit(PayrollApi.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(PayrollApi.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/people/payrolls/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const payrollDB = await updateFunc({
      ...pick(payroll, ['_key', '_id', '_rev']),
      ...values,
    })
    if (payrollDB) setPayroll(payrollDB)
  }

  const [removing, removeFunc] = useSubmit(PayrollApi.remove)

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      case 'remove':
        {
          const removed = await removeFunc({
            ...pick(payroll, ['_key', '_rev', '_id']),
          })
          if (removed)
            props.history.replace({
              pathname: `/people/payrolls/`,
            })
        }
        break
      case 'approve':
        {
          const ObjectDB = await submitOperation({
            status: operation,
            ...pick(payroll, ['_key', '_rev', '_id']),
          })
          if (ObjectDB) {
            fetch()
            message.success(
              <span>
                Payroll Claims have been created you can check{' '}
                <a href="#/people/payrollClaims/" target={'_blank'}>
                  here
                </a>
              </span>
            )
          }
        }
        break
      default: {
        const ObjectDB = await submitOperation({
          status: operation,
          ...pick(payroll, ['_key', '_rev', '_id']),
        })
        if (ObjectDB) {
          fetch()
        }
      }
    }
    hide()
  }

  const isNew = type === MODAL_TYPE_NEW
  const isApproved = payroll.status === 'Approved'
  const { tableRef, selection, selectAll, setSelection, toggleSelection, toggleAll, isSelected } = useSelectionTable()
  const [submittingPayClaim, submitPayClaim] = useSubmit(PayrollApi.payclaim)

  async function createPayClaim() {
    const payClaim = await submitPayClaim(payroll._key, selection)
    if (payClaim) {
      setSelection([])
      props.history.replace({
        pathname: `/people/payrollClaims/${payClaim._key}/update/`,
      })
    }
  }

  return (
    <AddPayroll
      {...{
        isNew,
        key,
        type,
        fetch,
        fetching,
        payroll,
        actions,
        fetchingActions,
        fetchActions,
        generating,
        generatedData,
        onGenerate,
        submitting,
        updating,
        submit,
        removing,
        update,
        formRef,
        handleActions,
        isApproved,
        submittingPayClaim,
        createPayClaim,
        // table selection
        tableRef,
        selection,
        selectAll,
        setSelection,
        toggleSelection,
        toggleAll,
        isSelected,
      }}
    />
  )
}

AddPayrollCont.propTypes = {}
AddPayrollCont.defaultProps = {}

export default withRouter(AddPayrollCont)
